module.exports = __webpack_public_path__ + "media/photo/insights-f0e66d2f.jpg";